import axios from "axios";
import { API_URL } from "../constant";
import { warnIfOriginBlocked } from "./axiosConfig";

/**
 * The client for auth itself: the session bootstrap (`api/users/me`) and logout.
 *
 * It exists purely because it must NOT carry axiosConfig's 401 handler. That handler does a
 * hard `window.location.href = "/login"`, and the bootstrap probe is *expected* to 401 when
 * nobody is signed in — that 401 is how it reports "logged out". Routing the probe through
 * the shared instance turns every logged-out page load into a redirect loop: mount → probe →
 * 401 → reload → mount.
 *
 * So: same credentials, same origin diagnostic, no redirect. auth-context interprets the
 * 401 itself.
 */
const sessionAxios = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

sessionAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    warnIfOriginBlocked(error);
    return Promise.reject(error);
  }
);

export default sessionAxios;
